import app from 'flarum/forum/app';
import { override, extend } from 'flarum/common/extend';
import IndexPage from 'flarum/forum/components/IndexPage';
import DiscussionList from 'flarum/forum/components/DiscussionList';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import ItemList from 'flarum/common/utils/ItemList';
import setRouteWithForcedRefresh from 'flarum/common/utils/setRouteWithForcedRefresh';
const topics = [{
  name: 'Getting Started',
  slug: 'getting-started',
  icon: 'fas fa-rocket'
}, {
  name: 'Account & Dashboard',
  slug: 'account-dashboard',
  icon: 'fas fa-user-cog'
}, {
  name: 'Store Setup',
  slug: 'store-setup',
  icon: 'fas fa-store'
}, {
  name: 'Orders',
  slug: 'orders',
  icon: 'fas fa-receipt'
}, {
  name: 'Payments & Payouts',
  slug: 'payments-payouts',
  icon: 'fas fa-wallet'
}, {
  name: 'Products & Catalog',
  slug: 'products-catalog',
  icon: 'fas fa-box-open'
}, {
  name: 'Ads & Marketing',
  slug: 'ads-marketing',
  icon: 'fas fa-bullhorn'
}, {
  name: 'Technical Issues',
  slug: 'technical-issues',
  icon: 'fas fa-tools'
}];
function currentPath() {
  return m.route.get().split('?')[0];
}
function sidebar() {
  const path = currentPath();
  return m('.SellviaSidebar', [m('.SellviaSidebarBrand', [m('.SellviaBrandIcon', [m('i.fas.fa-comments')]), m('.SellviaBrandText', [m('strong', 'Sellvia Forum'), m('span', 'Help & Community')])]), m('.SellviaSidebarSection', 'FORUM'), m('a.SellviaNavItem' + (path === '/' ? '.is-active' : ''), {
    href: '/',
    oncreate: m.route.link
  }, [m('i.fas.fa-layer-group'), m('span', 'All Topics')]), m('.SellviaSidebarSection', 'HELP TOPICS'), topics.map(topic => m('a.SellviaNavItem' + (path === '/t/' + topic.slug ? '.is-active' : ''), {
    href: '/t/' + topic.slug,
    oncreate: m.route.link
  }, [m('i', {
    className: topic.icon
  }), m('span', topic.name), m('i.SellviaArrow.fas.fa-chevron-right')]))]);
}
function solutionMode() {
  const params = app.search.state.params();
  const filter = params.filter || {};
  if (filter['solved-discussions']) return 'solved';
  if (filter['-solved-discussions']) return 'unsolved';
  return 'latest';
}
function changeSolutionMode(mode) {
  const params = Object.assign({}, m.route.param());
  const filter = Object.assign({}, params.filter || {});
  delete filter['solved-discussions'];
  delete filter['-solved-discussions'];
  if (mode === 'solved') {
    filter['solved-discussions'] = 'true';
  }
  if (mode === 'unsolved') {
    filter['-solved-discussions'] = 'true';
  }
  if (Object.keys(filter).length) {
    params.filter = filter;
  } else {
    delete params.filter;
  }

  // Return to first page and default/latest sorting.
  delete params.page;
  delete params.sort;
  setRouteWithForcedRefresh(app.route(app.current.get('routeName'), params));
}
function openNewTopic() {
  if (!app.session.user) {
    app.modal.show(() => flarum.reg.asyncModuleImport('flarum/forum/components/LogInModal'));
    return;
  }
  return app.composer.load(() => flarum.reg.asyncModuleImport('flarum/forum/components/DiscussionComposer'), {
    user: app.session.user
  }).then(() => app.composer.show());
}
app.initializers.add('sellvia-forum-theme', () => {
  override(IndexPage.prototype, 'hero', function () {
    return m('.SellviaForumHeader', [m('.SellviaForumHeaderInner', [m('div', [m('.SellviaKicker', 'SELLVIA COMMUNITY'), m('h1', 'Sellvia Forum'), m('p', 'Practical answers, troubleshooting and help for using Sellvia.')]), m('button.SellviaNewTopic', {
      onclick: () => openNewTopic()
    }, [m('i.fas.fa-plus'), m('span', 'New Topic')])])]);
  });
  override(IndexPage.prototype, 'sidebar', function () {
    return sidebar();
  });
  override(IndexPage.prototype, 'contentItems', function () {
    const items = new ItemList();
    const mode = solutionMode();
    const isEmpty = !app.discussions.isInitialLoading() && !app.discussions.isLoadingNext() && app.discussions.isEmpty();
    let emptyTitle = 'No topics yet';
    let emptyText = 'Start the first discussion or choose a help topic from the menu.';
    if (mode === 'unsolved') {
      emptyTitle = 'No unsolved topics';
      emptyText = 'There are currently no discussions waiting for a solution.';
    }
    if (mode === 'solved') {
      emptyTitle = 'No solved topics yet';
      emptyText = 'Solved discussions will appear here once a best answer is selected.';
    }
    items.add('sellviaWorkspace', m('.SellviaWorkspace', [m('.SellviaWorkspaceHeader', [m('.SellviaWorkspaceTitle', [m('span.SellviaWorkspaceEyebrow', 'COMMUNITY'), m('h2', 'Latest Topics'), m('p', 'Recent questions, discussions and practical solutions.')]), m('.SellviaWorkspaceActions', [this.actionItems().toArray()])]), m('.SellviaFilterBar', [m('.SellviaFilterTabs', [m('button.SellviaFilterTab' + (mode === 'latest' ? '.is-active' : ''), {
      onclick: () => changeSolutionMode('latest')
    }, 'Latest'), m('button.SellviaFilterTab' + (mode === 'unsolved' ? '.is-active' : ''), {
      onclick: () => changeSolutionMode('unsolved')
    }, 'Unsolved'), m('button.SellviaFilterTab' + (mode === 'solved' ? '.is-active' : ''), {
      onclick: () => changeSolutionMode('solved')
    }, 'Solved')])]), m('.SellviaWorkspaceBody', [isEmpty ? m('.SellviaEmptyState', [m('.SellviaEmptyIcon', [m('i.far.fa-comments')]), m('h3', emptyTitle), m('p', emptyText), mode === 'latest' ? m('button.SellviaEmptyButton', {
      onclick: () => openNewTopic()
    }, [m('i.fas.fa-plus'), 'New Topic']) : null]) : m(DiscussionList, {
      state: app.discussions
    })])]), 100);
    return items;
  });

  /* sellvia-premium-topic-rows */

  extend(DiscussionListItem.prototype, 'infoItems', function (items) {
    const discussion = this.attrs.discussion;
    const firstPost = discussion.firstPost && discussion.firstPost();
    const raw = firstPost && firstPost.contentPlain ? firstPost.contentPlain() : '';
    if (raw) {
      const clean = raw.replace(/\s+/g, ' ').trim();
      const excerpt = clean.length > 190 ? clean.slice(0, 187).trim() + '…' : clean;
      items.add('sellviaExcerpt', m('.SellviaTopicExcerpt', excerpt), -100);
    }
  });
  extend(DiscussionListItem.prototype, 'statsItems', function (items) {
    const discussion = this.attrs.discussion;
    if (discussion.hasBestAnswer && discussion.hasBestAnswer()) {
      items.add('sellviaSolved', m('.SellviaSolvedLabel', [m('i.fas.fa-check'), m('span', 'Solved')]), 100);
    }
  });
});